import React, { Component } from 'react';

class ItemAllCheckbox extends Component {
    render() {

        const { items , handleSelectAll } = this.props;
        const allCount = items.length;
        let allSelected = false;

        const selectedCount = items.filter(item => item.selected).length;
        const editableCount = items.filter(item => item.editable).length;

        if ((allCount > 0 ) && (selectedCount > 0 )) {
            if(selectedCount === editableCount){
                allSelected = true;
            }
        }

        return (
            <div className="check_blog">
                <input type="checkbox" id="inptCheck" className="inp_check" checked={allSelected} onChange={handleSelectAll} />
                <label htmlFor="inptCheck" className="ico_blog ico_checkbox">선택 됨</label>
            </div>
        );
    }
}

export default ItemAllCheckbox;
